const initialState = {
  apps: {},
  appsMainPage: {},
  fetch: false,
  unreadCount: 0,
};

export default initialState;
